import { render, staticRenderFns } from "./MainValues.vue?vue&type=template&id=5a5e433a&scoped=true&"
import script from "./MainValues.vue?vue&type=script&lang=js&"
export * from "./MainValues.vue?vue&type=script&lang=js&"
import style0 from "./MainValues.vue?vue&type=style&index=0&id=5a5e433a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5e433a",
  null
  
)

export default component.exports